/**
 * Único formateador de nombre de mes calendario ("YYYY-MM" → "jul") de la aplicación.
 * Antes convivían dos estrategias para el mismo dato: `index.tsx` usaba
 * `Intl.DateTimeFormat` directo y `FeedbackDetailPopup` pasaba por `toLocaleString` con
 * un mapa de locales aparte (`LOCALE_MAP`) — dos formatos posibles para el mismo mes en
 * la misma pantalla.
 */
export function formatMonthLabel(yearMonth: string, lang: string): string {
  const [year, monthNumber] = yearMonth.split('-').map(Number);
  return new Intl.DateTimeFormat(lang, { month: 'short' }).format(new Date(year, monthNumber - 1, 1));
}
